export default __webpack_public_path__ + "static/icon-2-2-b999fb8e4eaec0996a0e5cfebadc7ee3.png";